<template>
    <div class="index-tariff-tabs">
        <WBScroller class="index-tariff-tabs__wrapper" row>
            <template #default>
                <div v-for="tab in tabs"
                     :key="tab.value"
                     class="index-tariff-tabs__tab"
                     :class="{ _active: model === Number(tab.value), _discount: tab.discount }"
                     @click="handleClick(tab.value as number)"
                >
                    {{ tab.label }}

                    <span v-if="tab.discount" class="index-tariff-tabs__tab-cheep">
                        <span>{{ tab.discount }}</span>
                    </span>
                </div>
            </template>
        </WBScroller>
    </div>
</template>

<script setup lang="ts">
    import type { TariffTabItem } from '~/src/shared/components/pages/index/mock/indexTariff'

    defineProps<{
        tabs: TariffTabItem[]
    }>()

    const model = defineModel()

    function handleClick(value: number) {
        if (model.value !== value) {
            model.value = value
        }
    }
</script>

<style scoped lang="scss">
.index-tariff-tabs {
        @include hide-scrollbar;

        @include respond-to(tablet) {
            overflow-x: auto;
            overflow-y: hidden;
        }

        &__wrapper {
            width: 100%;
        }

        &__tab {
            display: flex;
            flex-shrink: 0;
            margin-top: 24px;
            margin-bottom: 24px;
            padding: 8px 24px;
            border-radius: 20px;
            border: 1px solid var(--indigo-100);
            background-color: var(--white);
            cursor: pointer;
            user-select: none;

            @include mulish16r;

            &:not(:last-child) {
                margin-right: 12px;
            }

            &._active {
                background-color: var(--blue-600);
                color: var(--white);
                box-shadow: 0 4px 25px 0 #193A9140;
            }

            &._discount {
                padding-right: 12px;
            }
        }

        &__tab-cheep {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-left: 10px;
            padding: 6px 8px;
            border-radius: 20px;
            background-color: var(--indigo-100);
            font-family: var(--accent-font), sans-serif;
            font-size: 16px;
            font-weight: 600;
            line-height: 11px;
            color: var(--blue-400);

            span {
                display: inline-block;
                height: 11px;
            }
        }
    }
</style>
